import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import CompanyMessages from '../../components/views/common/CompanyMessages'
import injectRole from '../../components/HOC/injectRole'

import { TRoles, TRoutes } from '../../shared/const'

/**
 * Nachrichten der Verwaltung zu einem Unternehmen — fuer Schueler:innen und
 * Lehrkraefte. Wer darf welchen Verlauf sehen, entscheidet das Backend
 * (`/api/private/common/company-log/:id`); hier faellt nur die Rolle weg,
 * fuer die die Seite gar nicht gedacht ist.
 */
function CompanyMessagesPage(props) {
	if ([TRoles.STUDENT, TRoles.TEACHER].includes(props.role)) return <CompanyMessages />
	return <Redirect to={TRoutes.DASHBOARD} />
}

CompanyMessagesPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(CompanyMessagesPage)
